// extracted by mini-css-extract-plugin
export default {"errorTitle":"error-title--Hxwt1Z3ObOnsBmcY8WlN","errorSubTitle":"error-sub-title--HZtirSKJ8d50KOzXK9WY"};